export default function ($http) {
    return function (vehicleId, enquiryId, updateBillingDetailsModel) {
        return $http.put(`api/vehicles/${vehicleId}/enquiries/${enquiryId}/updatebillingdetails`, updateBillingDetailsModel);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/enquiries/updateBillingDetails.js